import React from 'react';

import { AmazonParcelTable } from '../../HubCounters/Parcels/AmazonParcelTable';
import { HubCounter } from '../query';

type AmazonParcelsProps = {
  hubCounter?: Pick<HubCounter, 'amazonAccessPointId' | 'hubCounterID'> | null;
};

export const AmazonParcels = ({ hubCounter }: AmazonParcelsProps) => {
  const lockedAmazonAccessPointIds = [hubCounter?.amazonAccessPointId, hubCounter?.hubCounterID].filter(Boolean) as string[];

  return (
    <AmazonParcelTable
      lockedAmazonAccessPointIds={lockedAmazonAccessPointIds}
      showStats={false}
      showHubCounterFilter={false}
      syncUrl={false}
      embedded
    />
  );
};

export default AmazonParcels;
